var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-box"},[(_vm.selItemPos)?_c('animate-box',{ref:"selBgBox",staticClass:"sel-bg",style:({
    width: ((_vm.selItemPos.w) + "px"),
    height: ((_vm.selItemPos.h) + "px"),
    transform: ("translate(" + (_vm.selItemPos.x) + "px, " + (_vm.selItemPos.y) + "px)"),
    transition: ("all " + _vm.dur + "ms")
  }),attrs:{"color":"#a3cdda","direction":_vm.boxAnimeDir}}):_vm._e(),_c('ul',{class:{menu: true, 'line-mode': _vm.mode === 'line', 'stack-mode': _vm.mode === 'stack' }},_vm._l((_vm.itemsPos),function(item){return _c('li',{key:item.text,class:{item: true, selected: _vm.sel === item.text},style:({
        width: ((item.w) + "px"),
        height: ((item.h) + "px"),
        transform: ("translate(" + (item.x) + "px, " + (item.y) + "px)"),
        transition: ("all " + _vm.dur + "ms")
      }),on:{"click":function($event){return _vm.itemClicked(item)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }